import { render, staticRenderFns } from "./PeriodsForm.vue?vue&type=template&id=6378ea8b&scoped=true&"
import script from "./PeriodsForm.vue?vue&type=script&lang=js&"
export * from "./PeriodsForm.vue?vue&type=script&lang=js&"
import style0 from "./PeriodsForm.vue?vue&type=style&index=0&id=6378ea8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6378ea8b",
  null
  
)

export default component.exports